import React, {useState,useEffect} from 'react'
import {Card, CardBody, Col, Input, Row} from "reactstrap";

// components
import WlCardHeader from "../components/WlCardHeader";
import WlCardComment from "../components/WlCardComment";
import WishlistButtons from "../tools/WishlistButtons";

// labels
import {
    LB_AIRLINE, LB_AIRPORT, LB_DATE, LB_DELIVER, LB_DELIVER_INDICATOR,
    LB_FLIGHT, LB_FLIGHT_HOUR, LB_FLIGHT_NUMBER, LB_INTERNATIONAL,
    LB_NATIONAL, LB_PICKUP, LB_PICKUP_HOUR, LB_PICKUP_HOUR_REQUIRED, LB_PICKUP_INDICATOR, LB_TERMINAL, LB_TYPE,
} from "../../i18n/i18n";

//utils
import {getWishlistOption, wishlistStatus, wishlistTypes} from "../../../util/WishlistUtils";

const TransportViewComponent = props => {
    const option = getWishlistOption( wishlistTypes?.transportation )

    const [pickupHour, setPickupHour] = useState(props.component?.pickupHour)
    const [enabledConfirmation, setEnabledConfirmation] = useState(true)

    useEffect(() => {
        setEnabledConfirmation(pickupHour ? true: false)
    },[pickupHour])

    const onPickupHourChange = e => setPickupHour(e.target.value)

    return <Card className={'wl-card'}>
        <CardBody className={'wl-card-content'}>
            <WlCardHeader
                icon={ option?.icon }
                title={ option?.title }
                subTitle={props?.component?.pickupDeliver ? LB_PICKUP_INDICATOR : LB_DELIVER_INDICATOR}
                pax={props?.component?.pax}
            />


            <div className={'wl-card-body ptb-1em mb-1em'}>
                <Row>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_AIRPORT}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.airport?.name}</label>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-55px'}>{LB_TERMINAL}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.terminal?.number}</label>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-55px'}>{LB_AIRLINE}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.airline?.name}</label>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-55px'}>{LB_DATE}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.date}</label>
                        </div>
                        <div>
                            <label className={'wl-label-title w-55px'}>{LB_TYPE}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.pickupDeliver ? LB_PICKUP : LB_DELIVER}</label>
                        </div>
                        <div>
                            <label className={'wl-label-title w-55px'}>{LB_FLIGHT}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.isNational ? LB_NATIONAL : LB_INTERNATIONAL}</label>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-90px'}>{LB_FLIGHT_HOUR}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.hour}</label>
                        </div>
                        <div>
                            <label className={'wl-label-title w-70px'}>{LB_FLIGHT_NUMBER}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.flightNumber}</label>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div style={{"float": "left"}}>
                            <label className={'wl-label-title'}>{LB_PICKUP_HOUR}</label> &nbsp;
                            <label className={'wl-label-value'}>
                                {
                                    (props?.component?.status) === wishlistStatus.confirmed.description
                                        ? <label className={'wl-label-value'}>{pickupHour}</label>
                                        : <Input
                                            type={'time'}
                                            size={'sm'}
                                            value={pickupHour}
                                            onChange={onPickupHourChange}
                                        />
                                }

                            </label> &nbsp;
                        </div>
                        <div>
                            <label className={`wl-label-value-alert ${enabledConfirmation && 'v-hidden'}`}>
                                {LB_PICKUP_HOUR_REQUIRED}
                            </label>
                        </div>
                    </Col>
                </Row>
            </div>

            <WlCardComment comment={props?.component?.comments}/>

            <WishlistButtons from={'wishlist'} {...props} enabledConfirmation={enabledConfirmation} pickupHour={pickupHour} />
        </CardBody>
    </Card>
}

export default TransportViewComponent